import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TranslationProvider from 'i18n/Provider';
import createSagaMiddleware from 'redux-saga';
import customResourceMiddleware from 'store/middleware/customResourceMiddleware';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import history from 'services/history';
import loadingReducer from 'store/reducers/loaderReducer';
import localeReducer from 'store/reducers/localeReducer';
import theme from 'theme/theme';
import { ConnectedRouter, routerReducer, routerMiddleware } from 'react-router-redux';
import { Provider } from 'react-redux';
import { AUTH_LOGOUT_SUCCESS } from 'store/actions/types';
import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import { fork } from 'redux-saga/effects';
import { reducer as formReducer } from 'redux-form';
import { sagaExceptionReporter } from 'helpers/Logging/sentry';
import Routes from 'routes/Route';
import sagas from 'store/sagas';
import reducers from 'store/reducers/reducers';
import messages from 'i18n/messages';
import preferredLanguage from 'helpers/preferredLanguage';

const Admin = (props) => {
    const {
        configuration,
    } = props;

    /**
     * Do we really need this reducer function?
     * @todo We can delete these and use the this.context.configuration where the languages are set.
     */
    const locale = preferredLanguage(configuration.language.system, messages);

    /**
     * Setting up all the reducers.
     * @todo move this to the services folder.
     */
    const appReducer = combineReducers({
        locale: localeReducer(locale),
        form: formReducer,
        loading: loadingReducer,
        routing: routerReducer,
        ...reducers,
    });

    /**
     * This will reset the redux flow when the user is logged out.
     */
    const resettableAppReducer = (state, action) => {
        let result = state;

        if (action.type === AUTH_LOGOUT_SUCCESS) {
            result = undefined;
        }

        return appReducer(result, action);
    };

    const saga = function* rootSaga() {
        yield [
            ...sagas,
        ].map(fork);
    };

    const sagaMiddleware = createSagaMiddleware();

    const store = createStore(
        resettableAppReducer,
        compose(
            applyMiddleware(
                sagaExceptionReporter,
                sagaMiddleware,
                routerMiddleware(history),
                ...customResourceMiddleware,
            ),
            window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => {
                return f;
            },
        ),
    );

    sagaMiddleware.run(saga);

    const muiTheme = getMuiTheme(theme);

    return (
        <Provider store={ store }>
            <TranslationProvider messages={ messages }>
                <ConnectedRouter history={ history }>
                    <MuiThemeProvider muiTheme={ muiTheme }>
                        <Routes />
                    </MuiThemeProvider>
                </ConnectedRouter>
            </TranslationProvider>
        </Provider>
    );
};

Admin.propTypes = {
    configuration: PropTypes.shape({
        language: PropTypes.shape({
            system: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default Admin;



// WEBPACK FOOTER //
// ./src/components/layout/Admin/Admin.js